import { trustStats } from '@/mocks/categories';

export default function TrustBar() {
  return (
    <section className="bg-background-50 border-b border-background-200/70">
      <div className="container-page py-5 md:py-6">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-10">
          {trustStats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-2 text-sm text-foreground-600 whitespace-nowrap">
              <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className={`${stat.icon} text-base`}></i>
              </div>
              <span className="font-medium">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}